import {
  STORE_LOGIN_EMAIL
} from './type'

export const storeLoginEmail = ( payload ) => ({ type: STORE_LOGIN_EMAIL, payload })